module.exports = __webpack_public_path__ + "static/media/toon4.707fc6b4.png";